import React from 'react';

import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';

import { PACKAGE_NAME } from '../../../model/constants.tsx';
import { WhiteboardsAllJirasButton } from './view.tsx';

export const WhiteboardsAllJiras = () => {
	return (
		<JSErrorBoundary
			id="whiteboards-all-jiras-button"
			packageName={PACKAGE_NAME}
			teamName="starburst"
		>
			<ContextualAnalyticsData
				sourceName="planOnWhiteboardBacklogButton"
				sourceType={SCREEN}
				attributes={{
					growthInitiative: 'cross-flow',
					experiment: 'expandPlanOnWhiteboardsToAllJiras',
				}}
			>
				<WhiteboardsAllJirasButton />
			</ContextualAnalyticsData>
		</JSErrorBoundary>
	);
};
